<template>
  <v-card>
    <v-card-title>
      <p class="pl-6">{{ $tc("skills.categories.title", 2) }}</p>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        :label="$t('common.search')"
        single-line
        hide-details
      >
      </v-text-field>
    </v-card-title>
    <p class="pa-5">{{ $t("skills.categories.description") }}</p>
    <v-spacer></v-spacer>

    <v-data-table
      :headers="headers"
      :items="list"
      :loading="loading"
      item-key="number"
      class="elevation-1"
      :footer-props="footer"
      :loading-text="$t('common.loading')"
      :no-results-text="$t('common.no_results')"
      :server-items-length="$store.state.skill_category.totalCount"
      :options.sync="options"
      dense
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
                {{ $t("common.add") }}
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="text-h5">{{ $t(formTitle) }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-textarea
                        rows="2"
                        v-model="editedItem.name"
                        :label="$t('common.name')"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">
                  {{ $t("common.cancel") }}
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="_submit()"
                  :loading="loading"
                >
                  {{ $t("common.save") }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:no-data>
        {{ $t("common.no_results") }}
      </template>
      <template v-slot:item.name="{ item }">
        {{ item.name }}
      </template>
      <template #item.skill="{ item }">
        <v-checkbox
          :value="item.id"
          multiple
          @change="updateSkills(item)"
          v-model="skills"
        />
      </template>
      <template #item.intervention="{ item }">
        <v-checkbox
          :value="item.id"
          multiple
          @change="updateInterventions(item)"
          v-model="interventions"
        />
      </template>
      <template v-slot:item.actions="{ item }">
        <EditDelete
          @edit="editItem(item)"
          @delete="
            remove('skill_category', Object.assign({ id: item.number }, item))
          "
        />
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { ADD, DELETE, FETCH, UPDATE } from "@/store/action-types"
import TableCrudMixin from "@/mixins/TableCrudMixin"
import { mapActions } from "vuex"
import TableMixin from "@/mixins/TableMixin"
import EditDelete from "@/components/form/EditDelete"

export default {
  name: "SkillCategoriesTable",
  components: { EditDelete },
  mixins: [TableCrudMixin, TableMixin],
  data: () => ({
    skills: [],
    interventions: [],
    editedItem: {
      name: "",
      classification: "",
      goal_one: "",
      goal_two: "",
      goal_three: "",
      category: {},
    },
  }),
  mounted() {},
  computed: {
    list() {
      return this.$store.state.skill_category.data
    },

    headers() {
      return [
        {
          value: "name",
          text: this.$tc("common.name", 1),
          sortable: false,
        },

        {
          value: "actions",
          align: "right",
        },
      ]
    },
  },

  methods: {
    ...mapActions("skill_category", [FETCH, ADD, DELETE, UPDATE]),

    _submit() {
      this.submit(["name", "id"])
    },
  },
}
</script>
